import { AuthenticatedApiClient } from '@guiker/asset-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAssetAuthenticatedApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
